import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog, Slide } from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import AddClientMaster from "./AddClientMaster";
import MessagePopup from "../../Utils/MessagePopup";
import { deleteItem, fetchAll, fetchById, postItem, FetchDataGet } from "../../../BaseUrl";
import {
  DELETECLIENT,
  EXPORTCLIENT,
  GETCLIENT,
  GETClientBYID,
  GETINDUSTRYDROPDOWN
} from "./Mutation";
import axios from "axios";
import { GETINDUSTRY } from "../IndustryMaster/Mutation";
import OptionConvert from "../../Utils/OptionConvert";
import AccessComponent from "../../Utils/AccessComponent";
import LoadingSpinner from "../../loader/loadercomp";
import ExportDialog from "../../Utils/ExportDialog";
import countryCodes from "../../countryCodes.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ClientMaster() {
  const [ClientData, setClientData] = useState([]);
  const [oneClientData, setOneClientData] = useState([]);
  const [isView, setIsView] = useState(false);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });
  const [Loader, setLoader] = useState(false);
  const [industryData, setIndustryData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [countryState, setCountryState] = useState([]);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [openExport, setOpenExport] = useState(false);
  const [serverPage, setServerPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");

  useEffect(() => {
    getIndustryData();
    getcountryoptions();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      let currentPage = serverPage;
      if (searchdata !== prevSearch) {
        setServerPage(1);
        currentPage = 1;
        setPrevSearch(searchdata);
      }
      getClientData(currentPage, searchdata);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchdata, serverPage]);

  const columns = [
    { label: "Client Name", field: "clientName" },
    { label: "Industry Type", field: "industryType" },
    { label: "Primary Contact", field: "primaryContactPerson" },
    { label: "Contact Number", field: "contactNumber" },
    { label: "Actions", field: "actions" },
  ];

  const validClientData = Array.isArray(ClientData) ? ClientData : [];

  const sortedData = [...validClientData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validClientData; // default to descending
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getcountryoptions = () => {
    const phoneOptions = countryCodes.map((item) => ({
      label: item.phone,
      value: item.phone,
    }));
    setCountryState((prevState) => ({
      ...prevState,
      countryCodeOptions: phoneOptions,
    }));
  };

  const formClose = () => {
    setOpen(false);
    setOneClientData([]);
    handleCloseDialog();
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  const addClient = () => {
    setIsView(false);
    setOpen(true);
  };

  const onView = (id) => {
    setIsView(true);
    getClientById(id);
    setOpen(true);
  };

  const onEdit = (id) => {
    setIsView(false);
    getClientById(id);
    setOpen(true);
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  //delete popup function
  const onDelete = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete Client ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteRole(id),
    });
  };

  //delete api call
  const deleteRole = async (id) => {
    const variables = {
      id: id,
    };
    try {
      const response = await deleteItem(DELETECLIENT, { input: variables });
      if (response?.deleteClient?.success === true) {
        setClientData(response?.deleteClient?.data);
        setPopup({
          open: true,
          message: response?.deleteClient?.message,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: response?.deleteClient?.message,
          severity: "error",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        message: error,
        severity: "success",
      });
      console.error(error);
    } finally {
      getClientData(serverPage, searchdata);
      handleCloseDialog();
    }
  };

  //get api call
  const getClientData = async (page = serverPage, search = searchdata) => {
    setLoader(true);
    setIsLoading(true);
    try {
      const variables = {
        search: search,
        page: page,
        pageSize: 10,
      };
      const response = await FetchDataGet(GETCLIENT, variables);
      if (response?.getAllClients?.success === true) {
        setTotalCount(response?.getAllClients?.totalCount || 0);
        const data = response?.getAllClients?.data.map((v, i) => ({
          id: v.id || i + 1,
          clientName: v.clientName || "N/A",
          industryType: v?.industry?.industryType || "N/A",
          hiringType: v.hiringType || "N/A",
          primaryContactPerson: v.primaryContactPerson || "N/A",
          address: v.address || "N/A",
          mailAddress: v.mailAddress || "N/A",
          countryCode: v.countryCode || "N/A",
          contactNumber: v.contactNumber || "N/A",
          mapLocation: v.mapLocation || "N/A",
          srDays: v.srDays || "N/A",
          createdAt: formatDate(v.createdAt) || "N/A",
          createdBy: v.createdBy || "N/A",
          lastUpdate: formatDate(v.lastUpdate) || "N/A",
          updatedBy: v.updatedBy || "N/A",
        }));

        setClientData(data);
      } else {
        setClientData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
    setIsLoading(false);
  };

  //get by id api call
  const getClientById = async (id) => {
    const variables = {
      id: id,
    };
    try {
      const response = await fetchById(GETClientBYID, variables);
      if (response?.getClientById?.success === true) {
        setOneClientData(response?.getClientById?.data);
      } else {
        setOneClientData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  //get industry option api call
  const getIndustryData = async () => {
    try {
       const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      const response = await FetchDataGet(GETINDUSTRYDROPDOWN,variables);
      if (response?.getAllIndustries?.success === true) {
        const option = OptionConvert(
          response?.getAllIndustries?.data,
          "industryType",
          "id",
          "hiringType"
        );
        setIndustryData(option);
      } else {
        setIndustryData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Client Master"
    >
      {Loader && <LoadingSpinner />}
      <ConfirmDialog //confirmation pop component
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <MessagePopup //error or succes pop component
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={sortedData}
        fileName="Client"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="Client Master" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addClient();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + {oneClientData.length > 0 ? "Update" : "Add"} Client
          </MaterialButton>
        </AccessComponent>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <AddClientMaster
            formClose={formClose}
            getClientData={getClientData}
            oneClientData={oneClientData}
            setPopup={setPopup}
            isView={isView}
            countryState={countryState}
            industryData={industryData}
            handleOpenDialog={handleOpenDialog}
            setDialogData={setDialogData}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        name="Client Master"
        isLoading={isLoading}
        serverPage={serverPage}
        totalCount={totalCount}
        onPageChange={(event, newPage) => setServerPage(newPage)}
      />
    </DashboardLayout>
  );
}

export default ClientMaster;
